import { render, staticRenderFns } from "./SupplierRawMaterialPackagingTransport.vue?vue&type=template&id=76d38486&scoped=true"
import script from "./SupplierRawMaterialPackagingTransport.vue?vue&type=script&lang=js"
export * from "./SupplierRawMaterialPackagingTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d38486",
  null
  
)

export default component.exports